import { SxProps, Theme } from '@mui/material';

export const htmlContentStylesSx: SxProps<Theme> = (theme: Theme) => ({
	a: {
		color: theme.palette.secondary.main,
		textDecoration: 'none',
	},
});
